import React from 'react';
import Toolbar from '../Toolbar/Toolbar';
import Footer from '../Footer/Footer';
const layout = (props) => {

    return (
        <React.Fragment>
            <Toolbar />
            {props.children}
            <Footer />
        </React.Fragment>
    );

}

export default layout;